<template>
  <div class="hospitalFrame">
    <div class="title">收到渔民救助呼叫...</div>
    <div
      class="join circle"
      @click="join()"
    >
      <div class="join-text">接听</div>
    </div>


    <audio ref="click1" class="audio" src="~@/assets/14474.mp3" controls
           :hidden="true"></audio>
  </div>
</template>

<script>
import util from '@/api/util.js';
import server from '@/api/hospital.js';
export default {
  data () {
    return {
      user: {},
      roomID: '',
      bCurrentPage: false,
    }
  },

  mounted () {
    this.user = util.userData() || {}
    this.bCurrentPage = true;
    this.roomID = this.$route.query.roomID
    if (this.roomID) {
      this.timeConnect()
    }
    this.startPlay()

  },
  methods: {
    startPlay() {
      //play A
      this.$refs.click1.play();
      //play B after 1000ms
      setInterval( this.startPlay,2000);
    },
    join () {
      server.joinRoom({
        userId: this.user.userID,
        roomId: this.roomID
      }).then((res) => {
        if (res.data) {
          this.bCurrentPage = false;
          util.router('connect?roomID=' + this.roomID);
        }
      }).catch(() => {
        setTimeout(() => {
          this.bCurrentPage = false;
          util.router("/doctors");
        }, 600)
      })
    },
    timeConnect () {
      const This = this
      setTimeout(() => {
        if (this.bCurrentPage) {
          server.checkMeeting().then((res) => {
            if (!res.data) {
              this.bCurrentPage = false;
              util.router("/doctors");
            } else {
              This.timeConnect()
            }
          });
        }
      }, 5000)
    },
  }
}
</script>

<style scoped>
.join {
  position: fixed;
  margin-top: calc(30vh);
  position: absolute;
  background-color: #07c160;
  text-align: center;
  width: 16rem;
  height: 16rem;
  border-radius: 50rem;
  cursor: pointer;
}
.join-text {
  margin-top: 30%;
  font-size: 5rem;
}
.title {
  font-size: 5rem;
  margin-top: 4rem;
}
.hospitalFrame {
  background: rgb(65, 73, 88);
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 6rem;
  color: #fff;
}




.block {
  width: 400px;
  height: 300px;
  padding: 50px;
  border: 1px solid red;
  /* background: #000735; */
}

@keyframes twinkling {
  0% {
    opacity: 0.2;
    filter: alpha(opacity=20);
    transform: scale(1);
  }

  50% {
    opacity: 0.5;
    filter: alpha(opacity=50);
    transform: scale(1.2);
  }

  100% {
    opacity: 0.2;
    filter: alpha(opacity=20);
    transform: scale(1);
  }
}


.circle {
  background: #3a96e1;
  text-align: center;
  font-weight: bold;
  line-height: 100px;
  z-index: 1;
}

.circle::before {
  background: inherit;
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: -2;
  border-radius: 50%;
  animation: twinkling 2.2s ease-in-out infinite;
}

.circle::after {
  background: inherit;
  content: '';
  position: absolute;
  width: 110%;
  height: 110%;
  left: -5%;
  top: -5%;
  z-index: -1;
  border-radius: 50%;
  animation: twinkling 2.2s ease-in-out infinite;
}

.circle2 {
  line-height: 80px;
  font-size: 12px;
  background: #d67c61;
}
</style>
